module.exports = require('./helpers/bundle-url').getBundleURL('bu0dN') + "57f82f074d9af_001.81e39e2d.png";